// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape, PlateTargetEligibility} from 'pipelines/StepShapeUtils';

export const PLATES_TO_DATASETS_STEP_SHAPES = [
  {
    stepType: PipelineStepType.PLATES_TO_DATASETS,
    isDeprecated: false,
    version: 0,
    plateTargetEligibility: PlateTargetEligibility.ANY,
    inputDataShapes: {
      inputPlates: {
        systemName: 'inputPlates',
        displayName: 'Input plates',
        kind: PipelineStepDataKind.PLATE,
        isMulti: true,
        isRequired: true
      }
    },
    outputDataShapes: {
      outputDatasets: {
        systemName: 'outputDatasets',
        displayName: 'Output datasets',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: true
      }
    },
    config: {
      layers: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'enum',
          required: true,
          choices: [
            {
              value: 'label',
              displayName: 'Label'
            },
            {
              value: 'concentration_design',
              displayName: 'Concentration Design'
            },
            {
              value: 'content',
              displayName: 'Content'
            },
            {
              value: 'metadata',
              displayName: 'Metadata'
            }
          ]
        },
        minItems: 1
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
